<template>
  <div class="question-content">
    <nav>
      <li v-for="(item, index) in showQuestionList" :key="index">
        <div class="content">
          <span v-if="item.knowledge_name"
          class="content__title">{{ item.knowledge_name }}</span>
          <!-- 试题内容主体 -->
          <div class="content__count">
            <p>{{ item.num }}、</p>
            <p
              v-katexHtml="item.content.content"
              v-if="scienceArr.includes(Number(categoryObj.subjectId))"
            />
            <p v-katexUbb="htmlDeCode(item.content.content)" v-else />
          </div>
          <!-- 英语听力 -->
          <div
            class="content__audio"
            v-if="
              item.content.hearing.length &&
              item.content.hearing[0] &&
              item.content.hearing[0].source
            "
            @click="controlAudio(item.question_uuid)"
          >
            <p
              class="audio-pause"
              :class="
                isAudioPlaying && currentQuestionUuid === item.question_uuid
                  ? 'voice-playing'
                  : ''
              "
            ></p>
            <audio
              ref="audio"
              :id="`audio${item.question_uuid}`"
              :src="item.content.hearing[0].source"
              @pause="onPause"
              @play="onPlay"
            />
          </div>
          <!-- 选词填空 -->
          <div
            v-if="item && item.question_type === 6 && item.show_type === '112'"
            class="content__option query-block-container"
          >
            <div
              class="query-block"
              v-for="(oitem, oindex) in item.choice_words"
              :key="oindex"
            >
              <p v-katexUbb="htmlDeCode(oitem.content)"></p>
            </div>
          </div>
          <!-- 填空题 -->
          <!-- <div
            v-if="item && item.question_type === 3 && item.show_type === '102'"
            class="content__option"
          >
            <div v-for="(oitem, oindex) in item.answer" :key="oindex">
              <p>{{ oindex + 1 }}、</p>
              <p v-katexUbb="htmlDeCode(oitem[0].content)"></p>
            </div>
          </div> -->
          <!-- 判断题 -->
          <div
            v-if="item && item.question_type === 3 && item.show_type === '103'"
            class="content__option"
          >
            <div
              v-for="(oitem, oindex) in Number(categoryObj.subjectId) === 1
                ? enText
                : cnText"
              :key="oindex"
            >
              <p>{{ oitem }}</p>
            </div>
          </div>
          <!-- 试题选项 -->
          <div
            class="question-analysis__option"
            v-if="item.question_title_uuid === ''"
          >
            <div v-for="(oitem, oindex) in item.options" :key="oindex">
              <p>{{ oitem.key }}：</p>
              <p v-katexHtml="oitem.content"></p>
            </div>
          </div>
          <!-- 题冒题 -->
          <ul v-if="item.question_title_uuid !== ''">
            <li v-for="(qItem, qIndex) in item.question_list" :key="qIndex">
              <div class="content__count">
                <p>{{ qIndex + 1 }}、</p>
                <p v-katexUbb="htmlDeCode(qItem.content.content)" />
              </div>
              <!-- 听力题 -->
              <div
                class="content__audio"
                v-if="
                  qItem.content.hearing.length &&
                  qItem.content.hearing[0] &&
                  qItem.content.hearing[0].source
                "
                @click="controlAudio(qItem.question_uuid)"
              >
                <p
                  class="audio-pause"
                  :class="
                    isAudioPlaying &&
                    currentQuestionUuid === qItem.question_uuid
                      ? 'voice-playing'
                      : ''
                  "
                ></p>
                <audio
                  ref="audio"
                  :id="`audio${qItem.question_uuid}`"
                  :src="qItem.content.hearing[0].source"
                  @pause="onPause"
                  @play="onPlay"
                />
              </div>
              <!-- 选词填空 -->
              <div
                v-if="
                  qItem &&
                  qItem.question_type === 6 &&
                  qItem.show_type === '112'
                "
                class="content__option query-block-container"
              >
                <div
                  v-for="(oitem, oindex) in qItem.choice_words"
                  class="query-block"
                  :key="oindex"
                >
                  <p v-katexUbb="htmlDeCode(oitem.content)"></p>
                </div>
              </div>
              <!-- 填空题 -->
              <!-- <div
                v-if="
                  qItem &&
                  qItem.question_type === 3 &&
                  qItem.show_type === '102'
                "
                class="content__option"
              >
                <div v-for="(oitem, oindex) in qItem.answer" :key="oindex">
                  <p v-katexUbb="htmlDeCode(oitem[0].content)"></p>
                </div>
              </div> -->
              <!-- 判断题 -->
              <div
                v-if="
                  qItem &&
                  qItem.question_type === 3 &&
                  qItem.show_type === '103'
                "
                class="content__option"
              >
                <div
                  v-for="(oitem, oindex) in Number(categoryObj.subjectId) === 1
                    ? enText
                    : cnText"
                  :key="oindex"
                >
                  <p>{{ oitem }}</p>
                </div>
              </div>
              <div class="content__option" v-else>
                <div v-for="(oitem, oindex) in qItem.options" :key="oindex">
                  <p>{{ oitem.key }}：</p>
                  <p v-katexUbb="htmlDeCode(oitem.content)"></p>
                </div>
              </div>
            </li>
          </ul>
          <!-- 试题底部操作按钮 -->
          <div class="content__footer">
            <div>
              <p>
                <span>题型: </span>
                <span v-if="scienceArr.includes(Number(categoryObj.subjectId))">
                  {{ item.question_type_name }}
                </span>
                <span v-else>{{
                  questionType(
                    item.p_k_module,
                    item.question_type,
                    item.show_type,
                    item.question_title_uuid
                  )
                }}</span>
              </p>
              <p>
                <span>难度: </span>
                <span>{{ item.difficulty }}</span>
              </p>
            </div>
            <div class="footer__right">
              <p
                class="tickling pointer"
                @click="submitAnalysis(item.question_uuid)"
                v-if="!isPad"
              >
                反馈
              </p>
              <p class="analysis pointer">
                <span
                  v-if="item.active"
                  style="margin-left: 6px"
                  @click="closeAnalysis(item)"
                  >收起解析</span
                >
                <span
                  v-else
                  style="margin-left: 6px"
                  @click="openAnalysis(item)"
                  >查看解析</span
                >
              </p>
              <div v-if="fromPage !== 'FromResource'">
                <p
                  class="putOut pointer"
                  @click="PutOutBasket(item)"
                  v-if="includesThisQuestion(item)"
                >
                  移除
                </p>
                <button class="basket" @click="PutInBasket(item)" v-else>
                  <span class="basket-content">选入试题篮</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- 试题解析内容 -->
        <ul class="question-analysis" v-if="item.active">
          <li class="question-analysis__answer">
            <span style="min-width: 110px">正确答案:</span>
            <!-- 理科正确答案 -->
            <div
              class="f-x-c"
              v-if="scienceArr.includes(Number(categoryObj.subjectId))"
            >
              <div v-if="item.question_type !== 3">
                <span
                  v-for="(aitem, aindex) in item.answer"
                  :key="aindex"
                  class="right-answer"
                  v-katexHtml="aitem"
                ></span>
              </div>
              <div v-else class="completion">
                <div v-for="(aitem, aindex) in item.answer" :key="aindex">
                  <div
                    v-for="(childItem, childIndex) in aitem"
                    :key="childIndex"
                  >
                    <span
                      v-katexUbb="childItem.content"
                      class="right-answer"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 文科正确答案 -->
            <div class="f-x-c" v-else>
              <!-- 题冒题的答案处理 -->
              <div v-if="item.question_title_uuid !== ''">
                <div
                  v-for="(qItem, qIndex) in item.question_list"
                  :key="qIndex"
                  class="question-arr"
                >
                  <p class="question-index">{{ `[小题${qIndex + 1}]` }}</p>

                  <div
                    v-for="(aItem, aIndex) in qItem.answer"
                    :key="aIndex"
                    class="answer-arr"
                  >
                    <div
                      v-if="
                        qItem.question_type === 3 || qItem.question_type === 6
                      "
                    >
                      <div
                        v-for="(cItem, cIndex) in aItem"
                        :key="cIndex"
                        class="right-answer"
                      >
                        <div v-if="qItem.show_type === '103'">
                          <span v-if="Number(categoryObj.subjectId) === 3">
                            {{ cItem.content === "T" ? "正确" : "错误" }}
                          </span>
                          <span v-else>
                            {{ cItem.content === "T" ? "True" : "False" }}
                          </span>
                        </div>
                        <div
                          v-else
                          v-katexUbb="htmlDeCode(cItem.content)"
                        ></div>
                      </div>
                    </div>
                    <span v-else class="right-answer">
                      {{ aItem }}
                    </span>
                  </div>
                </div>
              </div>
              <div v-else>
                <div
                  v-if="item.question_type === 3 || item.question_type === 6"
                >
                  <div v-for="(aItem, aIndex) in item.answer" :key="aIndex">
                    <div
                      v-for="(cItem, cIndex) in aItem"
                      :key="cIndex"
                      class="answer-arr"
                    >
                      <div v-if="item.show_type === '103'" class="right-answer">
                        <span v-if="Number(categoryObj.subjectId) === 3">
                          {{ cItem.content === "T" ? "正确" : "错误" }}
                        </span>
                        <span v-else>
                          {{ cItem.content === "T" ? "True" : "False" }}
                        </span>
                      </div>
                      <div
                        class="right-answer"
                        v-else
                        v-katexUbb="htmlDeCode(cItem.content)"
                      ></div>
                    </div>
                  </div>
                </div>
                <span v-else class="right-answer">
                  {{ item.answer }}
                </span>
              </div>
            </div>
          </li>
          <li class="question-analysis__text" v-if="item.analyze">
            <span style="min-width: 110px">文字解析:</span>
            <!-- 理科文字解析 -->
            <div v-if="scienceArr.includes(Number(categoryObj.subjectId))">
              <div
                v-for="(zitem, zindex) in item.analyze.content"
                :key="zindex"
                class="text-content"
              >
                <p v-katexHtml="zitem.content" />
              </div>
              <img
                :src="item.analyze.image[0].source"
                v-if="
                  item.analyze.image.length > 0 && item.analyze.image[0].source
                "
              />
            </div>
            <!-- 文科文字解析 -->
            <div v-else>
              <!-- 题冒题的文字解析处理 -->
              <div v-if="item.question_title_uuid !== ''">
                <div
                  v-for="(qItem, qIndex) in item.question_list"
                  :key="qIndex"
                  class="question-arr"
                >
                  <p class="question-index">{{ `[小题${qIndex + 1}]` }}</p>
                  <div v-for="(aItem, aIndex) in qItem.analyze" :key="aIndex">
                    <div
                      v-if="aItem.title"
                      v-katexUbb="htmlDeCode(aItem.title)"
                    />
                    <p>
                      <span
                        v-for="(cItem, cIndex) in aItem.content"
                        :key="cIndex"
                        v-katexUbb="htmlDeCode(cItem.content)"
                      >
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div v-else>
                <div
                  v-if="item.analyze.title"
                  v-katexUbb="htmlDeCode(item.analyze.title)"
                />
                <div
                  v-for="(zitem, zindex) in item.analyze.content"
                  :key="zindex"
                  class="text-content"
                >
                  <p v-html="htmlDeCode(zitem.content)"></p>
                </div>
                <img
                  :src="item.analyze.image[0].source"
                  v-if="
                    item.analyze.image.length > 0 &&
                    item.analyze.image[0].source
                  "
                />
              </div>
            </div>
          </li>
          <li
            class="question-analysis__videos"
            v-if="item.question_source && item.question_source.length > 0"
          >
            <p>视频解析:</p>
            <p
              class="video-content"
              @click.stop="videoOpen(item.question_source[0].source_url)"
            >
              <span>播放</span>
            </p>
          </li>
        </ul>
      </li>
    </nav>
    <div v-if="showQuestionList.length < 1" class="empty">
      <img src="../../images/emptyType.png" alt="" />
    </div>
    <!-- 分页 -->
    <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="questionList.length"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="currentPage"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    <!-- 反馈弹框 -->
    <analysis-dialog
      :centerDialogVisible.sync="centerDialogVisible"
      :questionUUid="questionUUid"
    />
    <!-- 视频弹框 -->
    <video-dialog :dialogVisible.sync="dialogVisible" :videoUrl="videoUrl" />
  </div>
</template>
<script>
import { htmlDecodeByRegExp } from '@/utils';
import _ from 'lodash';
import { getQuestionDetailById } from '@/api/pt';
import analysisDialog from '../../lesson-prepare/components/analysis-dialog.vue';
import videoDialog from '../../lesson-prepare/components/video-dialog.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'QuestionContent',
  props: {
    questionList: {
      type: Array,
      default: () => [],
    },
    fromPage: {
      type: String,
      default: 'FromSyncTest',
    },
  },
  components: {
    analysisDialog,
    videoDialog,
  },
  watch: {
    questionList: {
      handler() {
        this.pageSize = 10;
        this.currentPage = 1;
        this.getShowQuestionList();
      },
      immediate: true,
    },
  },
  data() {
    return {
      currentQuestionUuid: '',
      cnText: ['正确', '错误'],
      enText: ['True', 'False'],
      isAudioPlaying: false,
      currentAudioUrl: '',
      scienceArr: [2, 4, 5],
      // total: 0, // 总数
      isPad: this.$route.query.spad,
      pageSize: 10,
      currentPage: 1,
      centerDialogVisible: false,
      dialogVisible: false,
      videoUrl: '',
      questionUUid: '',
      questionsBasket: [],
      currentQuestionid: '',
      showQuestionList: [],
    };
  },
  computed: {
    ...mapGetters(['categoryObj']),
    videoType() {
      return function video(val) {
        if (val) {
          val.some((item) => item.video_data.length > 0);
        }
      };
    },
    includesThisQuestion() {
      const { questionsBasket } = this.$store.state;
      return function includesThisQuestion(val) {
        const str = questionsBasket.some((item) => item.question_uuid === val.question_uuid);
        if (str) {
          return true;
        }
        return false;
      };
    },
    questionType() {
      return function questionType(parent, question, show, title) {
        let name = '';
        if ([2, 3, 11].includes(Number(parent))) {
          const nameMap = {
            2: '听力题',
            3: '阅读题',
            11: '完形题',
          };
          name = nameMap[Number(parent)];
        } else if (question === 1 && show === '100' && title === '') {
          name = '单选题';
        } else if (question === 2 && show === '101' && title === '') {
          name = '多选题';
        } else if (question === 3 && show === '102' && title === '') {
          name = '填空题';
        } else if (question === 3 && show === '103' && title === '') {
          name = '判断题';
        } else if (question === 6 && show === '112' && title === '') {
          name = '选词填空';
        }
        return name;
      };
    },
  },
  methods: {
    videoOpen(val) {
      this.dialogVisible = true;
      this.videoUrl = val;
    },
    submitAnalysis(uuid) { // 反馈
      this.questionUUid = uuid;
      this.centerDialogVisible = true;
    },
    openAnalysis(item) {
      this.$set(item, 'active', true);
      this.currentQuestionid = item.question_uuid;
      if (!item.analyze) {
        this.getQuestionDetailById(item);
      }
    },
    closeAnalysis(item) {
      this.$set(item, 'active', false);
    },
    PutInBasket(question) {
      if (!this.includesThisQuestion(question)) {
        console.log('没有这道题-----------');
        this.$set(question, 'active', false);
        this.$store.commit('PUTIN_QUESTIONS_BASKET', question);
      } else {
        this.$message({
          message: '此题已存在',
          type: 'warning',
        });
      }
    },
    PutOutBasket(question) {
      this.$store.commit('PUTOUT_QUESTIONS_BASKET', question);
    },
    async getQuestionDetailById(item) {
      await getQuestionDetailById({ question_id: this.currentQuestionid }).then((res) => {
        if (res.code === 200) {
          const answerArr = [];
          const analyzes = _.get(res.data, 'analyze.0');
          const questionSource = _.get(res.data, 'question_source');
          const questionList = _.get(res.data, 'question_list');
          this.$set(item, 'analyze', analyzes);
          this.$set(item, 'question_source', questionSource);
          this.$set(item, 'question_list', questionList);
          if (item.question_title_uuid !== '') {
            questionList.forEach((question) => {
              answerArr.push(question.answer);
            });
            this.$set(item, 'answer', answerArr);
          }
        }
      });
    },
    handleSizeChange(v) {
      this.pageSize = v;
      if (this.currentPage === 1) {
        this.getShowQuestionList();
      } else {
        this.currentPage = 1;
        this.getShowQuestionList();
      }
    },
    handleCurrentChange(v) {
      this.currentPage = v;
      this.getShowQuestionList();
    },
    getShowQuestionList() {
      this.questionList.forEach((item, index) => {
        this.$set(item, 'num', index + 1);
      });
      this.showQuestionList = JSON.parse(JSON.stringify(this.questionList.slice(
        (this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize,
      )));
    },
    // 转换html字符串
    htmlDeCode(str) {
      return htmlDecodeByRegExp(str, 1);
    },
    // 音频播放状态
    onPlay() {
      console.log('音频开始播放了');
      // this.isAudioPlaying = true;
    },
    // 音频暂停状态
    onPause() {
      console.log('音频暂停了');
      this.isAudioPlaying = false;
    },
    controlAudio(index) {
      const id = `audio${index}`;
      if (this.currentQuestionUuid === index && this.isAudioPlaying) {
        this.isAudioPlaying = false;
        this.$refs.audio.forEach((item) => {
          if (item.id === id) {
            item.pause();
          }
        });
      } else if (this.currentQuestionUuid === index && !this.isAudioPlaying) {
        this.isAudioPlaying = true;
        this.$refs.audio.forEach((item) => {
          if (item.id === id) {
            item.play();
          }
        });
      } else if (this.currentQuestionUuid !== index && !this.isAudioPlaying) {
        this.currentQuestionUuid = index;
        this.isAudioPlaying = true;
        this.$refs.audio.forEach((item) => {
          if (item.id === id) {
            item.play();
          } else {
            item.pause();
          }
        });
      } else if (this.currentQuestionUuid !== index && this.isAudioPlaying) {
        this.currentQuestionUuid = index;
        this.$refs.audio.forEach((item) => {
          if (item.id === id) {
            item.play();
          } else {
            item.pause();
          }
        });
      }
      console.log('currentQuestionUuid----------', this.currentQuestionUuid);
      // this.currentQuestionUuid = index;
      // this.$refs.audio.forEach((item) => {
      //   if (item.id === id) {
      //     item.play();
      //     console.log('item-------------', item.id);
      //   }
      //   if (item.id === id && this.isAudioPlaying) {
      //     item.pause();
      //   }
      // });
    },
  },
};
</script>
<style lang="scss" scoped>
.question-content {
  min-height: 500px;
  width: 100%;
  position: relative;
  .f-x-c {
    display: flex;
    align-items: center;
  }
  .query-block-container {
    flex-wrap: wrap;
  }
  .query-block {
    border: 1px solid rgba(216, 220, 230, 1);
    color: rgba(90, 94, 102, 1);
    font-size: 14px;
    border-radius: 14px;
    margin-right: 16px;
    margin-bottom: 16px;
    max-width: 80%;
    box-sizing: border-box;
    padding: 4px 13px;
  }
  .content {
    min-height: 148px;
    border: 3px solid rgba(118, 194, 255, 0.14);
    border-radius: 12px;
    padding-top: 17px;
    margin-left: 28px;
    margin-top: 28px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    &__title {
      margin-left: 25px;
      display: inline-block;
      min-width: 89px;
      height: 24px;
      background: #f0f2f5;
      border-radius: 3px;
      border: 1px solid #d7dfec;
      font-size: 13px;
      color: #5a5e66;
      text-align: center;
      line-height: 24px;
    }
    &__count {
      margin: 16px 0;
      width: 584px;
      font-size: 15px;
      padding: 0 25px;
      color: #111f2c;
      line-height: 21px;
      display: flex;
    }
    &__audio {
      margin-left: 25px;
      margin-bottom: 16px;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: #f7ca08;
      .audio-pause {
        width: 36px;
        height: 36px;
        // border-radius: 50%;
        background: url("../../images/audio_pause.png") no-repeat center center;
        background-size: 22px 15px;
        &.voice-playing {
          background: url("../../images/audio_playing.gif") no-repeat center
            center;
          background-size: 22px 15px;
        }
      }
    }
    &__option {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      // border-bottom: 1px dashed #dce1eb;
      padding-bottom: 3px;
      font-size: 14px;
      div {
        display: flex;
        align-items: center;
        .content__option__item {
          min-width: 60px;
          height: 28px;
          background: #ffffff;
          border-radius: 14px;
          border: 1px solid #d8dce6;
          text-align: center;
          line-height: 28px;
        }
      }
    }
    &__footer {
      width: 100%;
      height: 48px;
      line-height: 48px;
      display: flex;
      padding-left: 25px;
      box-sizing: border-box;
      justify-content: space-between;
      background: url("../../images/footerbg.png") no-repeat;
      background-size: 100% 100%;
      div {
        display: flex;
        align-items: center;
        p {
          margin-right: 20px;
          font-size: 14px;
        }
      }
      .footer__right {
        color: #1989fa;
        font-size: 14px;
        .basket {
          display: inline-block;
          width: 108px;
          height: 32px;
          background: #1989fa;
          border-radius: 6px;
          line-height: 32px;
          text-align: center;
          color: #ffffff;
          margin-right: 20px;
          &.includes {
            background: #ffffff;
            color: #1989fa;
          }
          .basket-content {
            font-size: 14px;
            box-sizing: border-box;
            padding-left: 15px;
            background: url("../../images/add_witle.png") no-repeat left center;
            background-size: 12px 12px;
            &.includes {
              padding: 0px;
            }
          }
        }
        .tickling {
          background: url("../../images/feedback.png") no-repeat left center;
          background-size: 13px 17px;
          text-indent: 18px;
        }
        .analysis {
          background: url("../../images/examine-analysis.png") no-repeat left
            center;
          background-size: 13px 15px;
          text-indent: 18px;
        }
        .putOut {
          background: url("../../images/delete.png") no-repeat 20px center;
          background-size: 13px 15px;
          // text-indent: 18px;
          font-size: 14px;
          width: 108px;
          text-align: center;
        }
      }
    }
  }
  .question-analysis {
    margin-left: 48px;
    margin-right: 20px;
    // min-height: 219px;
    border: 3px solid rgba(118, 194, 255, 0.14);
    border-radius: 12px;
    padding: 15px 20px;
    &__option {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      border-bottom: 1px dashed #dce1eb;
      padding-bottom: 20px;
      font-size: 14px;
      div {
        display: flex;
        align-items: center;
      }
    }
    &__answer {
      font-size: 15px !important;
      color: #000000;
      line-height: 40px;
      border-bottom: 1px dashed #dce1eb;
      display: flex;
      .completion {
        display: flex;
        align-items: center;
      }
      .question-arr {
        display: flex;
        .question-index {
          min-width: 55px;
          font-size: 15px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          margin-right: 3px;
          display: inline;
          line-height: 1.4em;
        }
      }
      .answer-arr {
        // display: inline-block;
      }
      .right-answer {
        line-height: 42px;
        display: flex;
        justify-content: flex-start;
        color: #67c23a;
        margin-right: 10px;
        font-size: 15px !important;
        line-height: 1.4em;
      }
    }
    &__text {
      font-size: 15px;
      min-width: 120px;
      color: #000000;
      line-height: 53px;
      display: flex;
      .question-arr {
        display: flex;
        .question-index {
          min-width: 55px;
          margin-right: 3px;
          font-size: 15px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
        }
      }
      .answer-arr {
        display: inline-block;
      }
      .text-content {
        margin-top: 15px;
        p {
          line-height: 24px;
        }
      }
    }
    &__videos {
      margin-top: 17px;
      border-top: 1px dashed #dce1eb;
      font-size: 15px;
      color: #000000;
      height: 53px;
      display: flex;
      align-items: center;
      .video-content {
        display: inline-block;
        width: 84px;
        height: 28px;
        background: #ffa82d;
        border-radius: 14px;
        margin-left: 45px;
        line-height: 28px;
        span {
          font-size: 16px;
          display: inline-block;
          background: url("../../images/play_video.png") no-repeat left center;
          background-size: 24px 24px;
          box-sizing: border-box;
          padding-left: 32px;
          text-align: center;
          margin-left: 2px;
          color: #ffffff;
        }
      }
    }
  }
  .empty {
    img {
      width: 209px;
      height: 147px;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 30px;
    }
  }
  /deep/ .el-pagination {
    display: flex;
    position: absolute;
    padding-top: 20px;
    // width: calc(100% - 64px);
    bottom: -40px;
    left: 30px;
    .btn-prev {
      margin-left: auto;
    }
  }
}
</style>
